import { render, staticRenderFns } from "./groupbuy_company_mng_page.vue?vue&type=template&id=731c7d9d"
import script from "./groupbuy_company_mng_page.vue?vue&type=script&lang=js"
export * from "./groupbuy_company_mng_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('731c7d9d')) {
      api.createRecord('731c7d9d', component.options)
    } else {
      api.reload('731c7d9d', component.options)
    }
    module.hot.accept("./groupbuy_company_mng_page.vue?vue&type=template&id=731c7d9d", function () {
      api.rerender('731c7d9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/company/groupbuy_company_mng_page.vue"
export default component.exports